import { ParsedToken } from "firebase/auth";
import { createContext } from "react";

export const ClaimsContext = createContext<{ claims: ParsedToken | null }>({
  claims: null,
});
